// extracted by mini-css-extract-plugin
export default {"mainContainer":"DeliveryTargetEditor_mainContainer__l2m07","autocomplete":"DeliveryTargetEditor_autocomplete__M8q3W"};